import { z } from 'zod'

/**
 * Payload do evento `push` enviado pela API. Validado no service worker (antes
 * de exibir) e na aba (ao receber o repasse do SW) — nunca confiar no formato.
 */
export const pushPayloadSchema = z.object({
  notificacaoId: z.uuid(),
  tipo: z.enum([
    'COMUNICADO',
    'EVENTO',
    'ATENDIMENTO',
    'INVENTARIO',
    'CONTRACHEQUE',
    'ATESTADO',
    'FERIAS',
  ]),
  referenciaId: z.uuid().nullable(),
  titulo: z.string().min(1),
  mensagem: z.string(),
  // Banner opcional (Windows/Android). Só https; valor inválido vira `null` em vez
  // de derrubar a notificação inteira.
  imagemUrl: z
    .url({ protocol: /^https$/ })
    .nullish()
    .catch(null),
})

export type PushPayload = z.infer<typeof pushPayloadSchema>

/** Mensagens que o service worker envia para as abas abertas (`postMessage`). */
export const swMessageSchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal('PUSH_RECEIVED'), payload: pushPayloadSchema }),
  // Só caminho interno (começa com uma única `/`): evita navegação para fora do app.
  z.object({ type: z.literal('NAVIGATE'), url: z.string().regex(/^\/(?!\/)/) }),
  z.object({ type: z.literal('PUSH_SUBSCRIPTION_CHANGED') }),
])

export type SwMessage = z.infer<typeof swMessageSchema>

/** Corpo de `POST /notificacoes/push/inscricao`. */
export interface PushInscricaoRequest {
  endpoint: string
  p256dh: string
  auth: string
}
